// extracted by mini-css-extract-plugin
export default {"actionButton":"OBvZQk","primary":"efpTIQ","secondary":"IeTZCy","primaryActionMargin":"pH3DKH"};